var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-50 md-large-size-100"},[(_vm.spiralId !== null)?_c('Spiral',{ref:"spiral",attrs:{"id":_vm.spiralId,"shouldCopySpiral":_vm.shouldCopySpiral},on:{"saved":_vm.getSpirals,"close":function($event){_vm.spiralId = null}}}):_vm._e(),_c('SearchTable',{ref:"spiralTable",attrs:{"header":{
        title: 'Spirale',
        icon: 'animation',
        class: 'md-card-header-brand',
      },"queriedData":_vm.spirals,"metaData":_vm.spiralMetaData,"getItems":_vm.getSpirals,"params":_vm.spiralParams,"sortBy":'id',"individualFunction":[
        { function: _vm.copySpiral, class: 'md-round', icon: 'content_copy' } ],"forEachSelected":[
        {
          icon: 'delete',
          label: 'Briši',
          class: 'md-danger',
          function: _vm.deleteSpirals,
        } ],"openItem":_vm.openSpiral,"newItem":_vm.newSpiral}})],1),_c('div',{staticClass:"md-layout-item md-size-50 md-large-size-100"},[(_vm.paperId !== null)?_c('Paper',{attrs:{"id":_vm.paperId,"shouldCopyPaper":_vm.shouldCopyPaper},on:{"close":function($event){_vm.paperId = null},"saved":_vm.onPaperSaved}}):_vm._e(),_c('SearchTable',{ref:"papersTable",attrs:{"header":{
        title: 'Papiri',
        icon: 'file_copy',
        class: 'md-card-header-brand',
      },"queriedData":_vm.papers,"metaData":_vm.papersMetaData,"getItems":_vm.getPapers,"params":_vm.papersParams,"openItem":_vm.openPaper,"newItem":_vm.newPaper,"sortBy":'id',"individualFunction":[
        { function: _vm.copyPaper, class: 'md-round', icon: 'content_copy' } ],"forEachSelected":[
        {
          icon: 'delete',
          label: 'Briši',
          class: 'md-danger',
          function: _vm.deletePapers,
        } ]}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }